import React, { useState, useEffect } from 'react'
import Compressor from 'compressorjs'
import _, {
  parseInt, find, isNil,
} from 'lodash'
import moment from 'moment'
import numeral from 'numeral'
import {
  Div, P, Loading, Button, H4,
} from 'konsys-ui'
import {
  Row, Col, AutoComplete, DatePicker, Checkbox, Select, Spin, message, Modal, Button as AntButton, Collapse,
} from 'antd'
import { Query, Mutation } from 'react-apollo'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'
import heic2any from 'heic2any'
import { theme } from '../../../styles/_variables'
import {
  DRIVER_LIST_IN_SHIPPING_ORDER, GAS_STATION_LIST, TRUCK_LIST_IN_SHIPPING_ORDER,
} from '../../../constants/graphql/query'
import {
 ASSIGN_DRIVER, ASSIGN_FUEL, ASSIGN_DELIVERED, CREATE_FUEL_ORDER,
} from '../../../constants/graphql/mutation'
import {
  TimePickerWithLabel, DatePickerWithLabel, InputWithLabelAndUnit, DropdownWithLabel, TextWithLabelAndUnit, mappingValueToText, InputWithLabelBlock, InputWithLabelAndUnitOneRow, InputWithLabelInt,
} from '../../../components/shipping-order-components'
import { fuelTypeList, statusList } from '../../filling-order-page/detail/component-renderer'
import { colorSelector, textStatusSelector } from '../../truck-page/list'
import { colorSelector as DriverColorSelector, textStatusSelector as DriverTextStatusSelector } from '../../driver-page/list/config'
import { fuelStatus, unitValue } from '../constants'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import { toSafeFloat } from '../../../utils/util-services'
import history from '../../../history'
import { mappingValueToTypeText } from '../../../components/filling-order-components'
import FILLING_COMPANY from '../../../constants/filling-order'
import PERMISSION from '../../../constants/permissions'
import { Uploader } from '../../../components/common'
import { specialReason } from '../../filling-order-page/constants'

const { color } = theme

const truckTypeSelector = (value) => {
  switch (value) {
    case 'PADOONGRICH':
      return 'ผดุงฤทธิ์'
    case 'JOINTCAR':
      return 'รถร่วมในเครือ'
    case 'OUTJOINTCAR':
      return 'รถร่วมนอก'
    default: return 'ไม่ระบุ'
  }
}

const customPanelStyle = {
  background: '#f7f7f7',
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  overflow: 'hidden',
}

// Convert HEIC/HEIF file to JPEG Blob using heic2any
const convertHeicToJpeg = async (file) => {
  const original = file && file.originFileObj ? file.originFileObj : file
  if (!original) return file
  const name = (original.name || '').toLowerCase()
  const type = (original.type || '').toLowerCase()
  const isHeic = type === 'image/heic' || type === 'image/heif' || name.endsWith('.heic') || name.endsWith('.heif')
  if (!isHeic) return file
  try {
    const result = await heic2any({ blob: original, toType: 'image/jpeg' })
    const jpegBlob = Array.isArray(result) ? result[0] : result
    const newName = `${(name || 'image').replace(/\.(heic|heif)$/i, '')}.jpg`
    const jpegFile = new File([jpegBlob], newName, { type: 'image/jpeg' })
    console.info('convertHeicToJpeg success')
    return jpegFile
  } catch (err) {
    return file
  }
}

const compressImage = file => new Promise((resolve) => {
  // Use File constructor if available, otherwise fallback to Blob
  // eslint-disable-next-line no-undef
  /* global File */
  if (typeof window.File === 'undefined') {
    resolve(file)
    return
  }
  // Only compress image files
  const isImage = (file.type || (file.originFileObj && file.originFileObj.type) || '').startsWith('image/')
  if (!isImage) {
    resolve(file)
    return
  }
  // eslint-disable-next-line no-new
  new Compressor(file.originFileObj || file, {
    quality: 0.6,
    mimeType: 'image/jpeg',
    success(result) {
      const compressedFile2 = new File([result], file.name, {
        type: result.type,
      })
      console.info('compressImage success')
      resolve(compressedFile2)
        // ...file,
        // originFileObj: result,
        // url: file.url,
        // uid: file.uid,
        // name: file.name || result.name,
    },
    error() {
      resolve(file) // fallback to original if error
    },
  })
})

export const compressFiles = (files) => {
  if (!Array.isArray(files) || files.length === 0) return Promise.resolve([])
  return Promise.all(files.map(async (f) => {
    const converted = await convertHeicToJpeg(f)
    return compressImage(converted)
  }))
}

// --------------- Driver --------------- //
export const AssignDriver = ({
  disabled, props, initialData, driver, setDriver, setFuelType, shippingOrderId, refetch, isUpdateMode, accessDriver, mutationVariables, footerChanged, setMutationVariables,
}) => {
  const haveInitial = !_.isUndefined(initialData) && !_.isNull(initialData.Driver.id)
  const haveTruckInitial = !_.isUndefined(initialData) && !_.isNull(initialData.Truck.id)

  const [platenumberSearch, setplatenumberSearch] = useState(undefined)
  const [buttonPushed, setButtonPushed] = useState(false)
  const [truckSelected, setTruckSelected] = useState(
    initialData
    ? {
      ...initialData.Truck,
      owner: initialData?.TruckOwner,
      trailer: initialData?.Trailer,
    }
    : {},
  )
  const [successModal, setSuccessModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isChoose, setIsChoose] = useState(false)
  const [save, setSave] = useState(false)

  const [assignDriverVariables, setAssignDriverVariables] = useState({
    id: parseInt(shippingOrderId, 10),
    truckId: haveTruckInitial ? initialData.Truck.id : undefined,
    driverId: haveTruckInitial ? initialData.Truck.driver.id : undefined,
    startTime: initialData ? initialData.startTime : undefined,
  })

  const onChange = (key, value) => {
    setAssignDriverVariables({
      ...assignDriverVariables,
      [key]: value,
    })
  }

  const [getDriverInShippingOrder, { data: driverInShippingOrderData, loading: driverInShippingOrderLoading }] = useLazyQuery(DRIVER_LIST_IN_SHIPPING_ORDER, {
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (driverInShippingOrderData) {
      const selectedDriver = find(driverInShippingOrderData.DriverListInShippingorder.lists, o => o.id === driver.id)
      if (!isNil(selectedDriver) && (selectedDriver.id !== driver.id || selectedDriver.status !== driver.status)) {
        setDriver(selectedDriver)
        setSave(true)
        setIsChoose(true)
        onChange('driverId', selectedDriver?.id)
      }
    }
  }, driverInShippingOrderData?.DriverListInShippingorder?.lists)

  const download = () => {
    setIsLoading(true)
    window.open(
      `${getURL().FILE_SERVER}/downloadfile/pdf/shippingorder/${initialData.id}?t=${getAccessToken()}`,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setIsLoading(false)
  }

  // const [useDefaultDriver, setUseDefaultDriver] = useState(haveInitial ? initialData.Driver.id === initialData.Truck.driver.id : haveTruckInitial && true)
  return (
    <Div>
      {
        (((!_.isUndefined(initialData) && haveInitial) || buttonPushed)) // Button expression
          ? <Div>
              <H4 bold color={theme.color.primaryColor} margin='0 0 16px 0'>จ่ายงาน</H4>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 8px 0' }}>
                <Col span={6}>
                  <P>ทะเบียนรถ *</P>
                </Col>
                <Col span={6}>
                  <P>ชนิดรถ</P>
                </Col>
                <Col span={8}>
                  <P>พนักงานขับประจำ</P>
                </Col>
              </Row>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
                <Col span={6}>
                  <Query
                    query={TRUCK_LIST_IN_SHIPPING_ORDER}
                    variables={{ plateNumber: platenumberSearch }}
                  >{(resp) => {
                    if (resp.loading && _.isUndefined(resp.data.TruckListInShippingorder)) return <Loading />
                    if (resp.error) return <P>เกิดข้อผิดพลาด</P>
                    const truckList = resp.data.TruckListInShippingorder.lists
                    const platenumbers = truckList.map(v => v.plateNumber)
                    return (
                      <span>
                        <AutoComplete
                          defaultValue={haveInitial || haveTruckInitial ? initialData.Truck.plateNumber : null}
                          disabled={disabled}
                          dataSource={platenumbers}
                          style={{ width: '70%' }}
                          onSelect={(e) => {
                            const selected = _.find(truckList, o => o.plateNumber === e)
                            setTruckSelected(selected)
                            setFuelType(selected.fuelType)
                            setSave(true)
                            // ------- auto select driver ------- //
                            setDriver(selected.driver)
                            setSave(true)
                            setIsChoose(true)
                            setAssignDriverVariables({
                              ...assignDriverVariables,
                              truckId: selected.id,
                            })
                            setMutationVariables({ ...mutationVariables, truckFiles: undefined })
                          }}
                          onSearch={e => setplatenumberSearch(e)}
                          placeholder='พิมพ์เพื่อค้นหา'
                        />
                        {
                          resp.loading && <Loading size='small' style={{ marginLeft: 8 }}/>
                        }
                      </span>
                    )
                  }}
                  </Query>
                </Col>
                <Col span={6}>{_.isEmpty(truckSelected) ? haveInitial || haveTruckInitial ? initialData?.Truck?.type?.nameTh : '-' : truckSelected?.type?.nameTh}</Col>
                <Col span={5}>{_.isEmpty(truckSelected) ? haveInitial || haveTruckInitial ? initialData?.Truck?.driver?.fullname : '-' : truckSelected?.driver?.fullname}</Col>
              </Row>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 8px 0' }}>
                <Col span={6}>
                  <P>ประเภทรถ</P>
                </Col>
                <Col span={6}>
                  <P>เจ้าของรถ</P>
                </Col>
                {/* {
                  !useDefaultDriver
                  && <Col span={6}>
                      <P>พนักงานขับรถ *</P>
                    </Col>
                } */}
                <Col span={6}>
                  <P>พนักงานขับรถ *</P>
                </Col>
              </Row>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
                <Col span={6}>{_.isEmpty(truckSelected) ? haveInitial || haveTruckInitial ? truckTypeSelector(initialData?.TruckOwner?.type) : '-' : truckTypeSelector(truckSelected.owner?.type)}</Col>
                <Col span={6}>{_.isEmpty(truckSelected) ? haveInitial || haveTruckInitial ? initialData?.TruckOwner?.nameTh : '-' : truckSelected.owner?.nameTh}</Col>
                {
                  // !useDefaultDriver
                  //   && [
                      <Col span={5} key={1}>
                        <span>
                          <Select
                            showSearch
                            // disabled={disabled || useDefaultDriver}
                            disabled={disabled}
                            style={{ width: '85%' }}
                            value={!_.isUndefined(driver.fullname) ? driver.fullname : haveInitial ? initialData.Driver.fullname : null}
                            loading={driverInShippingOrderLoading}
                            filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            onSelect={(e) => {
                              const selected = _.find(driverInShippingOrderData?.DriverListInShippingorder?.lists || [], o => o.id === e)
                              setDriver(selected)
                              setSave(true)
                              setIsChoose(true)
                              onChange('driverId', selected.id)
                              setMutationVariables({ ...mutationVariables, truckFiles: undefined })
                            }}
                            onSearch={(e) => {
                              getDriverInShippingOrder({
                                variables: {
                                  fullname: e,
                                  checkDate: moment(assignDriverVariables.startTime).format(),
                                },
                              })
                            }}
                            placeholder='พิมพ์ชื่อพนักงาน'
                          >
                            {
                              (driverInShippingOrderData?.DriverListInShippingorder?.lists || []).map(v => <Select.Option key={v.id} value={v.id} name={v.fullname}>{v.fullname}</Select.Option>)
                            }
                          </Select>
                        </span>
                    </Col>
                    // <Col span={7} key={2}>รหัสพนักงาน: {_.isEmpty(driverSelected) ? haveInitial ? initialData.Driver.employeeId : '-' : driverSelected.employeeId}</Col>,
                    // ]
                }
              </Row>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 8px 0' }}>
                <Col span={6}>
                  <P>ประเภทเชื้อเพลิง</P>
                </Col>
                <Col span={6}>
                  <P>เวลาออก *</P>
                </Col>
                <Col span={3}>
                  <P>เหลือตั๋วน้ำมัน</P>
                </Col>
                <Col span={3}>
                  <P>รอเบิก</P>
                </Col>
              </Row>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
                <Col span={6}>{_.isEmpty(truckSelected) ? haveInitial || haveTruckInitial ? mappingValueToTypeText(initialData.Truck.fuelType) : '-' : mappingValueToTypeText(truckSelected.fuelType)}</Col>
                <Col span={6}>
                  <DatePicker
                    defaultValue={haveInitial && moment(initialData.startTime)}
                    disabled={disabled}
                    showTime
                    placeholder='เลือกวัน-เวลา'
                    onChange={(e) => {
                      setSave(true)
                      setAssignDriverVariables({
                        ...assignDriverVariables,
                        startTime: moment(e).format(),
                      })
                      getDriverInShippingOrder({
                        variables: {
                          fullname: driver.fullname,
                          checkDate: moment(e).format(),
                        },
                      })
                    }}
                    onOk={(e) => {
                      setSave(true)
                      setAssignDriverVariables({
                        ...assignDriverVariables,
                        startTime: moment(e).format(),
                      })
                      getDriverInShippingOrder({
                        variables: {
                          fullname: driver.fullname,
                          checkDate: moment(e).format(),
                        },
                      })
                    }}
                  />
                </Col>
                <Col span={3}>{_.isEmpty(driver) ? haveInitial ? initialData.Driver.remainTickets : '-' : driver.remainTickets}</Col>
                <Col span={3}>{_.isEmpty(driver) ? haveInitial ? initialData.Driver.remainFuel : '-' : driver.remainFuel}</Col>
              </Row>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
                <Col span={6}>
                  <P>สถานะรถ:&nbsp;</P>
                  <H4
                    bold
                    color={colorSelector(
                      _.isEmpty(truckSelected)
                      ? (haveInitial || haveTruckInitial)
                        ? initialData.Truck.status
                        : undefined
                      : truckSelected.status,
                    )}
                  >{
                    textStatusSelector(_.isEmpty(truckSelected) ? (haveInitial || haveTruckInitial) ? initialData.Truck.status : '-' : truckSelected.status)
                  }</H4>
                </Col>
                <Col span={6}>
                  <Div>
                   <P margin='0 0 8px 0'>สถานะหางพ่วง {(truckSelected.trailer) ? `ทะเบียน ${truckSelected.trailer?.trailerPlate}: ` : '-'}</P>
                   {
                    (truckSelected.trailer)
                    && <H4
                      bold
                      color={colorSelector(truckSelected.trailer ? truckSelected.trailer?.status : undefined)}
                    >{
                      textStatusSelector(truckSelected.trailer ? truckSelected.trailer?.status : '-')
                    }</H4>
                   }
                  </Div>
                </Col>
                <Col span={12}>
                  <P>สถานะคนขับ:&nbsp;</P>
                  <H4
                    bold
                    color={DriverColorSelector(_.isEmpty(driver) ? haveInitial ? initialData.Driver.status : undefined : driver.status)}
                  >{
                    DriverTextStatusSelector(_.isEmpty(driver) ? haveInitial ? initialData.Driver.status : undefined : driver.status)
                  }</H4>
                </Col>
              </Row>
              {
                isUpdateMode && truckSelected.driver?.id !== driver.id && (
                  <Uploader
                    buttonText='อัพโหลดรูป'
                    onChange={e => setMutationVariables({ ...mutationVariables, truckFiles: e })}
                    data={(mutationVariables.truckFiles || []).map(file => (file.url ? { name: _.flatten(_.takeRight(_.split(file.url, '/'))), uid: file.url, url: file.url } : file)) || []}
                    isMultiple={true}
                    accept='image/*'
                    className='mt-4'
                    disabled={disabled}
                  />
                )
              }
              { isChoose && !_.isUndefined(driver) && driver.shippings?.length > 0 // !useDefaultDriver &&
                  && <Div margin='auto'>
                    <Div display='flex' flexDirection='row' margin='8px 0 32px 8px' justifyContent='center'>
                    <P bold color={color.primaryColor}>พนักงานขับรถนี้มีใบสั่งบรรทุกที่ได้รับบิลน้ำมันแล้ว แต่ยังไม่มีบันทึกการขนส่ง {driver.shippings?.length} ใบ</P>
                    </Div>
                    <Div display='flex' flexDirection='row' margin='8px 0 24px' justifyContent='center'>
                      <Col md={{ span: 1 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ลำดับ</P></Div></Col>
                      <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>เล่มที่</P></Div></Col>
                      <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>เลขที่</P></Div></Col>
                      <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ทะเบียนรถ</P></Div></Col>
                      <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ผู้จ้าง</P></Div></Col>
                      <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ปริมาณน้ำมัน</P></Div></Col>
                      <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ค่าน้ำมัน</P></Div></Col>
                    </Div>
                    {
                      _.map(driver.shippings, (v, index) => <Div display='flex' flexDirection='row' margin='8px 0 16px' justifyContent='center'>
                        <Col md={{ span: 1 }}><Div display='flex' justifyContent='center'><P>{index + 1}</P></Div></Col>
                        <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.shippingVolume}</P></Div></Col>
                        <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.shippingNumber}</P></Div></Col>
                        <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.Truck.plateNumber}</P></Div></Col>
                        <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.Customer.companyName}</P></Div></Col>
                        <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.FuelOrder.totalAmount}</P></Div></Col>
                        <Col md={{ span: 2 }}><Div display='flex' justifyContent='center'><P>{v.FuelOrder.price.toFixed(2)}</P></Div></Col>
                      </Div>)
                    }
                </Div>
                }
              {
                accessDriver
                  && <Mutation
                  mutation={ASSIGN_DRIVER}
                >{(doAssign, { loading }) => (
                  <Div
                    position='fixed'
                    height='72px'
                    bottom='0'
                    left='0'
                    right='0'
                    style={{ background: `${color.primaryColor}33` }}
                    display='flex'
                    justifyContent='flex-end'
                    alignItems='center'
                    padding='0 32px 0 0'
                    zIndex={1}
                  >
                    <Modal
                      title={`ใบสั่งบรรทุก (รหัส: ${initialData.shippingCode}) จ่ายงานสำเร็จ, ต้องการสร้างใบเบิกน้ำมันเลยหรือไม่?`}
                      visible={successModal}
                      footer={[
                        <AntButton key="back" disabled={isLoading} onClick={() => history.push('/shipping-order')}>
                          ภายหลัง
                        </AntButton>,
                        <AntButton key="submit" type="primary" disabled={isLoading} onClick={() => {
                          history.push({
                            pathname: `/shipping-order/edit/${shippingOrderId}`,
                            state: { accessFuel: true, refetchRemainingFuel: true },
                          })
                        }}>
                          สร้างใบเบิกน้ำมัน
                        </AntButton>,
                      ]}
                    >
                      <P margin='0 32px 0 0'>คุณต้องการพิมพ์ใบสั่งรถบรรทุกเลยหรือไม่</P>
                      <AntButton key="submit" type="primary" loading={isLoading} onClick={() => download(false)}>
                        พิมพ์ใบสั่งรถบรรทุก
                      </AntButton>
                    </Modal>
                    <Button
                      text='บันทึกการจ่ายงาน'
                      disabled={(disabled
                        || _.isUndefined(assignDriverVariables.truckId)
                        || _.isUndefined(assignDriverVariables.startTime) || _.isNull(assignDriverVariables.startTime) || assignDriverVariables.startTime === 'Invalid date'
                        || _.isUndefined(driver.id) || ((!save && !footerChanged) && isUpdateMode))
                        || (truckSelected.driver?.id !== driver.id && _.size(mutationVariables.truckFiles) <= 0)
                        || loading
                      }
                      onClick={async () => {
                        // Helper to build variables for doAssign
                        const buildAssignVariables = (images, truckFiles) => ({
                          ...assignDriverVariables,
                          driverId: driver.id,
                          expensesHighway: mutationVariables.expensesHighway,
                          expensesEntranceStart: mutationVariables.expensesEntranceStart,
                          expensesEntranceEnd: mutationVariables.expensesEntranceEnd,
                          expensesPickupStart: mutationVariables.expensesPickupStart,
                          expensesPickupEnd: mutationVariables.expensesPickupEnd,
                          expensesOther: mutationVariables.expensesOther,
                          feePickupHeavy: mutationVariables.feePickupHeavy,
                          feePierEntrance: mutationVariables.feePierEntrance,
                          feePickupNormal: mutationVariables.feePickupNormal,
                          feeOther: mutationVariables.feeOther,
                          remark: mutationVariables.remark,
                          images,
                          truckFiles,
                        })

                        // Handle response from doAssign
                        const handleResponse = (resp) => {
                          if (resp.data.AssignDriver.success) {
                            setAssignDriverVariables({ id: parseInt(shippingOrderId, 10) })
                            if (typeof refetch === 'function') {
                              refetch()
                            }
                            if (_.isNull(resp.data.AssignDriver.updatedShippingorder.FuelOrder.id)) {
                              setSuccessModal(true)
                            } else {
                              message.success(resp.data.AssignDriver.message)
                              history.push(`/shipping-order/view/${shippingOrderId}`)
                            }
                          } else {
                            message.error(resp.data.AssignDriver.message)
                          }
                        }

                        const imagesToCompress = mutationVariables.images || []
                        const truckFilesToCompress = mutationVariables.truckFiles || []

                        const needCompression = (imagesToCompress && imagesToCompress?.length > 0)
                          || (truckFilesToCompress && truckFilesToCompress?.length > 0)

                        if (needCompression) {
                          try {
                            const [compressedImages, compressedTruckFiles] = await Promise.all([
                              compressFiles(imagesToCompress),
                              compressFiles(truckFilesToCompress),
                            ])
                            const resp = await doAssign({
                              variables: buildAssignVariables(compressedImages, compressedTruckFiles),
                            })
                            handleResponse(resp)
                          } catch (err) {
                            message.error('เกิดข้อผิดพลาดในการบีบอัดไฟล์')
                          }
                          return
                        }

                        // No compression needed
                        doAssign({
                          variables: buildAssignVariables(mutationVariables.images, mutationVariables.truckFiles),
                        }).then(handleResponse)
                      }}
                    />
                  </Div>
                )}
                </Mutation>
              }
            </Div>
          : <Button
              {...props}
              onClick={() => {
                setButtonPushed(true)
              }}
              disabled={disabled}
            />
      }
    </Div>
  )
}

// --------------- Filling order --------------- //
export const AssignFillingOrder = ({
  disabled,
  props,
  initialData: defaultInitial,
  fuelType,
  shippingOrderId,
  refetch,
  accessFuel,
  mutationVariables,
  isSpecial = false,
  missingFuelAmount,
  requestedFuelAmount,
  setCreatingFuel,
  creatingFuel,
  isViewMode,
  accessSpecialFuel,
}) => {
  const initialData = isSpecial ? defaultInitial?.FuelOrders?.find(fo => fo.isSpecial) : defaultInitial?.FuelOrder
  const haveInitial = !_.isUndefined(defaultInitial) && !_.isNil(initialData?.id)

  return (
    <Div>
      <AssignFillingForm
        shippingOrderId={shippingOrderId}
        disabled={disabled}
        isSpecial={isSpecial}
        haveInitial={haveInitial}
        initialData={initialData}
        defaultInitial={defaultInitial}
        missingFuelAmount={missingFuelAmount}
        requestedFuelAmount={requestedFuelAmount}
        accessFuel={accessFuel}
        setCreatingFuel={setCreatingFuel}
        creatingFuel={creatingFuel}
        fuelType={fuelType}
        mutationVariables={mutationVariables}
        refetch={refetch}
        props={props}
        isViewMode={isViewMode}
        accessSpecialFuel={accessSpecialFuel}
      />
    </Div>
  )
}

// --------------- Flated Record --------------- //
export const FlatbedInfo = ({
  initialData, disabled, shippingOrderId, refetch, props, mutationVariables, accessDelivered, footerChanged,
}) => {
  const haveInitial = !_.isUndefined(initialData) && (!_.isNull(initialData.deliveryDate) || !_.isNull(initialData.pickedUpDate))
  const [buttonPushed, setButtonPushed] = useState(false)

  const style = {
    margin: '0 16px 0 0', width: '100%',
  }
  const [assignDeliveredVariables, setAssignDeliveredVariables] = useState({ id: parseInt(shippingOrderId, 10) })
  const onChangeHandler = (key, value, isFloat) => {
    setAssignDeliveredVariables({
      ...assignDeliveredVariables,
      [key]: isFloat ? parseFloat(value) : value,
    })
  }

  const deliveryDate = _.isUndefined(assignDeliveredVariables.deliveryDate) ? haveInitial ? initialData.deliveryDate : undefined : assignDeliveredVariables.deliveryDate
  const deliveryTime = _.isUndefined(assignDeliveredVariables.deliveryTime) ? haveInitial ? initialData.deliveryTime : undefined : assignDeliveredVariables.deliveryTime
  const pickedUpDate = _.isUndefined(assignDeliveredVariables.pickedUpDate) ? haveInitial ? initialData.pickedUpDate : undefined : assignDeliveredVariables.pickedUpDate
  const pickedUpTime = _.isUndefined(assignDeliveredVariables.pickedUpTime) ? haveInitial ? initialData.pickedUpTime : undefined : assignDeliveredVariables.pickedUpTime
  const feeTotal = _.isUndefined(assignDeliveredVariables.feeTotal) ? haveInitial ? initialData.feeTotal : undefined : assignDeliveredVariables.feeTotal
  const outTownFeeRate = _.isUndefined(assignDeliveredVariables.outTownFeeRate) ? haveInitial ? initialData.outTownFeeRate : undefined : assignDeliveredVariables.outTownFeeRate
  const specialFeeRate = _.isUndefined(assignDeliveredVariables.specialFeeRate) ? haveInitial ? initialData.specialFeeRate : undefined : assignDeliveredVariables.specialFeeRate
  const weightRecordId = _.isUndefined(assignDeliveredVariables.weightRecordId) ? haveInitial ? initialData.weightRecordId : undefined : assignDeliveredVariables.weightRecordId
  const emptySackAmount = _.isUndefined(assignDeliveredVariables.emptySackAmount) ? haveInitial ? initialData.emptySackAmount : undefined : assignDeliveredVariables.emptySackAmount
  return (
    <Div>
      {
        (((!_.isUndefined(initialData) && haveInitial) || buttonPushed))
          ? <Div padding='40px 0'>
              <H4 bold color={theme.color.primaryColor} margin='0 0 16px 0'>บันทึกการขนส่ง - แบบเที่ยว</H4>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
                <Col span={6}>
                  <DatePickerWithLabel
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.pickedUpDate : undefined,
                    value: !_.isUndefined(pickedUpDate) && moment(pickedUpDate),
                    id: 'pickedUpDate',
                    text: 'วันที่ขึ้นของ',
                    props: { ...style },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
                <Col span={6}>
                  <TimePickerWithLabel
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.pickedUpTime : undefined,
                    value: moment(pickedUpTime, 'HH:mm'),
                    id: 'pickedUpTime',
                    text: 'เวลาที่ขึ้นของ',
                    props: { ...style },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
                <Col span={6}>
                  <DatePickerWithLabel
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.deliveryDate : undefined,
                    value: !_.isUndefined(deliveryDate) && moment(deliveryDate),
                    id: 'deliveryDate',
                    text: 'วันที่นำส่ง',
                    props: { ...style },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
                <Col span={6}>
                  <TimePickerWithLabel
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.deliveryTime : undefined,
                    value: moment(deliveryTime, 'HH:mm'),
                    id: 'deliveryTime',
                    text: 'เวลาที่นำส่ง',
                    props: { ...style },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelBlock
                    margin='8px 0 0'
                    data={{
                      disabled,
                      defaultValue: !_.isUndefined(initialData) ? initialData.weightRecordId : undefined,
                      value: weightRecordId,
                      id: 'weightRecordId',
                      props: { ...style, title: { text: 'เลขที่ใบนำส่ง' } },
                    }}
                    onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelInt
                    margin='8px 0 0'
                    isInt
                    data={{
                      disabled,
                      defaultValue: !_.isUndefined(initialData) ? initialData.emptySackAmount : undefined,
                      value: emptySackAmount,
                      id: 'emptySackAmount',
                      props: { ...style, title: { text: 'จำนวนกระสอบเปล่า' } },
                    }}
                    onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelAndUnit
                    margin='8px 0 0'
                    isFloat={!disabled}
                    data={{
                      disabled,
                      defaultValue: !_.isUndefined(initialData) ? initialData.Customer.groupId === 6 ? numeral(initialData.feeTotal).format('0,0.000') : numeral(initialData.feeTotal).format('0,0.00') : undefined,
                      value: disabled ? initialData.Customer.groupId === 6 ? numeral(feeTotal).format('0,0.000') : numeral(feeTotal).format('0,0.00') : feeTotal,
                      id: 'feeTotal',
                      unit: 'บาท',
                      props: { ...style, title: { text: 'ค่าขนส่ง' } },
                    }}
                    onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelAndUnit
                    margin='8px 0 0'
                    isFloat={!disabled}
                    data={{
                      disabled,
                      value: disabled ? numeral(outTownFeeRate).format('0,0.00') : outTownFeeRate,
                      id: 'outTownFeeRate',
                      unit: 'บาท',
                      props: { ...style, title: { text: 'ค่าเที่ยวต่างจังหวัด' } },
                    }}
                    onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelAndUnit
                    margin='8px 0 0'
                    isFloat={!disabled}
                    data={{
                      disabled,
                      value: disabled ? numeral(specialFeeRate).format('0,0.00') : specialFeeRate,
                      id: 'specialFeeRate',
                      unit: 'บาท',
                      props: { ...style, title: { text: 'ค่าเที่ยวพิเศษ' } },
                    }}
                    onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  />
                </Col>
              </Row>
              {
                !_.isUndefined(initialData) && initialData.recordDate
                  && <Row>
                    <Col span={24}>
                      <P bold margin='16px 6px'>วันที่บันทึกการขนส่ง: {moment(initialData.recordDate).format('DD MMMM YYYY')}</P>
                    </Col>
                  </Row>
              }
              {
                accessDelivered
                  && <Mutation
                  mutation={ASSIGN_DELIVERED}
                >{(doAssign, { loading }) => (
                  <Div
                    position='fixed'
                    height='72px'
                    bottom='0'
                    left='0'
                    right='0'
                    style={{ background: `${color.primaryColor}33` }}
                    display='flex'
                    justifyContent='flex-end'
                    alignItems='center'
                    padding='0 32px 0 0'
                    zIndex={1}
                  >
                    <Button
                      text={props.text}
                      disabled={disabled
                        || _.isUndefined(deliveryDate) || deliveryDate === 'Invalid date'
                        || _.isUndefined(deliveryTime) || deliveryTime === 'Invalid date'
                        || (_.size(assignDeliveredVariables) === 1 && !footerChanged)
                        || loading
                      }
                      loading={loading}
                      onClick={() => {
                        doAssign({
                          variables: {
                            ...assignDeliveredVariables,
                            expensesHighway: mutationVariables.expensesHighway,
                            expensesEntranceStart: mutationVariables.expensesEntranceStart,
                            expensesEntranceEnd: mutationVariables.expensesEntranceEnd,
                            expensesPickupStart: mutationVariables.expensesPickupStart,
                            expensesPickupEnd: mutationVariables.expensesPickupEnd,
                            expensesOther: mutationVariables.expensesOther,
                            feePickupHeavy: mutationVariables.feePickupHeavy,
                            feePierEntrance: mutationVariables.feePierEntrance,
                            feePickupNormal: mutationVariables.feePickupNormal,
                            feeOther: mutationVariables.feeOther,
                            remark: mutationVariables.remark,
                            images: mutationVariables.images,
                          },
                        }).then((resp) => {
                          if (resp.data.AssignDelivered.success) {
                            message.success(resp.data.AssignDelivered.message)
                            setAssignDeliveredVariables({ id: parseInt(shippingOrderId, 10) })
                            history.push('/shipping-order')
                          } else message.error(resp.data.AssignDelivered.message)
                        })
                      }}
                    />
                  </Div>
                )}
                </Mutation>
              }
            </Div>
          : <Button
              {...props}
              onClick={() => setButtonPushed(true)}
              disabled={disabled}
            />
      }
    </Div>
  )
}

// --------------- Other Record --------------- //
export const OtherTypeInfo = ({
  initialData, disabled, shippingOrderId, refetch, props, mutationVariables, accessDelivered, footerChanged,
}) => {
  const haveInitial = !_.isUndefined(initialData) && (!_.isNull(initialData.deliveryDate) || !_.isNull(initialData.pickedUpDate))
  const [buttonPushed, setButtonPushed] = useState(false)

  const style = {
    margin: '0 16px 0 0', width: '100%',
  }
  const [assignDeliveredVariables, setAssignDeliveredVariables] = useState({
    id: parseInt(shippingOrderId, 10),
    roundWeight: toSafeFloat(initialData.roundWeight),
    feeRate: _.isNull(initialData.feeRate) ? 0 : initialData.feeRate,
    unit: initialData.unit,
  })
  const onChangeHandler = (key, value, isFloat) => {
    setAssignDeliveredVariables({
      ...assignDeliveredVariables,
      [key]: isFloat ? parseFloat(value) : value,
    })
  }

  const multipleChangeHandler = (keyArr, valArr) => { // only two with startWeight endWeight
    setAssignDeliveredVariables({ ...assignDeliveredVariables, [keyArr[0]]: valArr[0], [keyArr[1]]: valArr[1] })
  }

  const rateTypeSelector = (startWeight, endWeight, roundWeight) => {
    switch (initialData.rateType) {
      case 'START':
        return startWeight
      case 'END':
        return endWeight
      case 'MIN':
        return _.min([startWeight, endWeight])
      case 'ETC':
        return roundWeight
      default:
        return roundWeight
    }
  }
  const feeRate = _.isUndefined(assignDeliveredVariables.feeRate) ? haveInitial ? initialData.feeRate : undefined : assignDeliveredVariables.feeRate
  const truckOwnerFeeRate = _.isUndefined(assignDeliveredVariables.truckOwnerFeeRate) ? haveInitial ? initialData.truckOwnerFeeRate : undefined : assignDeliveredVariables.truckOwnerFeeRate
  const roundWeight = _.isUndefined(assignDeliveredVariables.roundWeight) ? haveInitial ? initialData.roundWeight : undefined : assignDeliveredVariables.roundWeight
  const unit = _.isUndefined(assignDeliveredVariables.unit) ? haveInitial ? initialData.unit : undefined : assignDeliveredVariables.unit
  const startWeightvalue = _.isUndefined(assignDeliveredVariables.startWeight) ? initialData.startWeight : assignDeliveredVariables.startWeight
  const endWeightvalue = _.isUndefined(assignDeliveredVariables.endWeight) ? initialData.endWeight : assignDeliveredVariables.endWeight
  const deliveryDate = _.isUndefined(assignDeliveredVariables.deliveryDate) ? haveInitial ? initialData.deliveryDate : undefined : assignDeliveredVariables.deliveryDate
  const deliveryTime = _.isUndefined(assignDeliveredVariables.deliveryTime) ? haveInitial ? initialData.deliveryTime : undefined : assignDeliveredVariables.deliveryTime
  const pickedUpDate = _.isUndefined(assignDeliveredVariables.pickedUpDate) ? initialData ? initialData.pickedUpDate : undefined : assignDeliveredVariables.pickedUpDate
  const pickedUpTime = _.isUndefined(assignDeliveredVariables.pickedUpTime) ? initialData ? initialData.pickedUpTime : undefined : assignDeliveredVariables.pickedUpTime
  const weightRecordId = _.isUndefined(assignDeliveredVariables.weightRecordId) ? haveInitial ? initialData.weightRecordId : undefined : assignDeliveredVariables.weightRecordId
  const truckWithCargoWeight = _.isUndefined(assignDeliveredVariables.truckWithCargoWeight) ? initialData.truckWithCargoWeight : assignDeliveredVariables.truckWithCargoWeight

  const divisor = (e) => {
    switch (e) {
      case unitValue.TON:
        return 1000
      case unitValue.KG:
        return 1
      case unitValue.H100:
        return 100
      case unitValue.H50:
        return 50
      case unitValue.H60:
        return 60
      default:
        return 1
    }
  }

  const totalWeight = _.isNaN(roundWeight / divisor(unit)) ? 0 : roundWeight / divisor(unit)
  return (
    <Div>
      {
        (((!_.isUndefined(initialData) && haveInitial) || buttonPushed))
          ? <Div padding='40px 0'>
              <H4 bold color={theme.color.primaryColor} margin='0 0 16px 0'>บันทึกการขนส่ง - แบบน้ำหนัก</H4>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
                <Col span={6}>
                  <DatePickerWithLabel
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.pickedUpDate : undefined,
                    value: !_.isUndefined(pickedUpDate) && moment(pickedUpDate),
                    id: 'pickedUpDate',
                    text: 'วันที่ขึ้นของ',
                    props: { ...style },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
                <Col span={6}>
                  <TimePickerWithLabel
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.pickedUpTime : undefined,
                    value: moment(pickedUpTime, 'HH:mm'),
                    id: 'pickedUpTime',
                    text: 'เวลาที่ขึ้นของ',
                    props: { ...style },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelAndUnit
                  maxLength={5}
                  isFloat={!disabled}
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.truckWithCargoWeight : undefined,
                    value: disabled ? numeral(truckWithCargoWeight).format('0,0.00') : truckWithCargoWeight,
                    id: 'truckWithCargoWeight',
                    unit: 'กิโลกรัม',
                    props: { ...style, title: { text: 'น้ำหนักรถรวมสินค้าต้นทาง' } },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
              </Row>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
                <Col span={6}>
                  <DatePickerWithLabel
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.deliveryDate : undefined,
                    value: !_.isUndefined(deliveryDate) && moment(deliveryDate),
                    id: 'deliveryDate',
                    text: 'วันที่นำส่ง',
                    props: { ...style },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
                <Col span={6}>
                  <TimePickerWithLabel
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.deliveryTime : undefined,
                    value: moment(deliveryTime, 'HH:mm'),
                    id: 'deliveryTime',
                    text: 'เวลาที่นำส่ง',
                    props: { ...style },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelBlock
                    data={{
                      disabled,
                      defaultValue: !_.isUndefined(initialData) ? initialData.weightRecordId : undefined,
                      value: weightRecordId,
                      id: 'weightRecordId',
                      props: { ...style, title: { text: 'เลขที่ใบนำส่ง *' } },
                    }}
                    onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
                {/* <Col span={6}>
                  <InputWithLabelBlock
                    data={{
                      disabled,
                      defaultValue: !_.isUndefined(initialData) ? initialData.bookingNo : undefined,
                      value: bookingNo,
                      id: 'bookingNo',
                      props: { ...style, title: { text: 'Booking No.' } },
                    }}
                    onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col> */}
              </Row>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
                <Col span={6}>
                  <InputWithLabelAndUnit
                  maxLength={5}
                  isFloat={!disabled}
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.startWeight : undefined,
                    value: disabled ? numeral(startWeightvalue).format('0,0.00') : startWeightvalue,
                    id: 'startWeight',
                    unit: 'กิโลกรัม',
                    props: { ...style, title: { text: initialData.Truck.type.nameTh === 'รถเรียบ' ? 'น้ำหนักต้นทาง' : 'น้ำหนักต้นทาง *' } },
                  }}
                  // onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  onChangeHandler={(key, value) => {
                    if (_.isNaN(value) || (value >= 0)) {
                      multipleChangeHandler([key, 'roundWeight'], [value, rateTypeSelector(toSafeFloat(value), toSafeFloat(endWeightvalue), roundWeight)])
                    }
                  }}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelAndUnit
                  maxLength={5}
                  isFloat={!disabled}
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.endWeight : undefined,
                    value: disabled ? numeral(endWeightvalue).format('0,0.00') : endWeightvalue,
                    id: 'endWeight',
                    unit: 'กิโลกรัม',
                    props: { ...style, title: { text: initialData.Truck.type.nameTh === 'รถเรียบ' ? 'น้ำหนักปลายทาง' : 'น้ำหนักปลายทาง *' } },
                  }}
                  // onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  onChangeHandler={(key, value) => {
                    if (_.isNaN(value) || (value >= 0)) {
                      multipleChangeHandler([key, 'roundWeight'], [value, rateTypeSelector(toSafeFloat(startWeightvalue), toSafeFloat(value), roundWeight)])
                    }
                  }}
                  />
                </Col>
                <Col span={8}>
                  <TextWithLabelAndUnit
                  data={{
                    id: 'weightDifference',
                    unit: 'กิโลกรัม',
                    text: 'น้ำหนักขาด/เกิน',
                    //  value: (!_.isUndefined(mutationVariables.startWeight)
                    // && !_.isUndefined(mutationVariables.endWeight) && !_.isEmpty(mutationVariables.startWeight) && !_.isEmpty(mutationVariables.endWeight))
                    // && parseInt(mutationVariables.startWeight, 10) - parseInt(mutationVariables.endWeight, 10),
                    value: (!_.isNaN(parseFloat(startWeightvalue)) && !_.isNaN(parseFloat(endWeightvalue)))
                        && numeral(parseFloat(endWeightvalue) - parseFloat(startWeightvalue)).format('(0,0.00)'),
                    props: { ...style },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  />
                </Col>
              </Row>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
                <Col span={6}>
                  <InputWithLabelAndUnit
                  isFloat={!disabled}
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.feeRate : undefined,
                    id: 'feeRate',
                    value: disabled ? numeral(feeRate).format('0,0.00') : feeRate,
                    unit: 'บาทต่อ',
                    props: { ...style, title: { text: 'อัตราค่าขนส่งที่คิดลูกค้า' } },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelAndUnit
                  isFloat={!disabled}
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.truckOwnerFeeRate : undefined,
                    id: 'truckOwnerFeeRate',
                    value: disabled ? numeral(truckOwnerFeeRate).format('0,0.00') : truckOwnerFeeRate,
                    unit: 'บาทต่อ',
                    props: { ...style, title: { text: 'อัตราค่าขนส่งที่คิดรถร่วม' } },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  />
                </Col>
                <Col span={6}>
                  <DropdownWithLabel
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.unit : undefined,
                    value: unit,
                    id: 'unit',
                    text: initialData.Truck.type.nameTh === 'รถเรียบ' ? 'หน่วย' : 'หน่วย *',
                    placeholder: 'เลือกหน่วย',
                    props: { ...style },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value)}
                  />
                </Col>
              </Row>
              <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
                <Col span={6}>
                  <InputWithLabelAndUnit
                  isFloat={!disabled}
                  data={{
                    disabled,
                    defaultValue: !_.isUndefined(initialData) ? initialData.roundWeight : undefined,
                    value: disabled ? numeral(roundWeight).format('0,0.00') : roundWeight,
                    id: 'roundWeight',
                    unit: `${initialData.unit === unitValue.TRIP ? 'เที่ยว' : 'กิโลกรัม'}`,
                    props: { ...style, title: { text: `${initialData.unit === unitValue.TRIP ? 'เที่ยวที่คิดเงิน' : 'น้ำหนักที่คิดเงิน'} *` } },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelAndUnit
                  data={{
                    disabled: true,
                    //  defaultValue: !_.isUndefined(initialData) ? initialData.totalWeight : undefined,
                    value: numeral(totalWeight).format('0,0.00'),
                    id: 'totalWeight',
                    unit: mappingValueToText(unit),
                    props: { ...style, title: { text: 'น้ำหนักสุทธิ' } },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  />
                </Col>
                <Col span={6}>
                  <InputWithLabelAndUnit
                  data={{
                    disabled: initialData.Truck.type.nameTh !== 'รถเรียบ',
                    defaultValue: !_.isUndefined(initialData) ? initialData.Customer.groupId === 6 ? numeral(initialData.feeTotal).format('0,0.000') : numeral(initialData.feeTotal).format('0,0.00') : undefined,
                    value: initialData.Customer.groupId === 6 ? numeral(totalWeight * feeRate).format('0,0.000') : numeral(totalWeight * feeRate).format('0,0.00'),
                    id: 'feeTotal',
                    unit: 'บาท',
                    props: { ...style, title: { text: 'ค่าขนส่ง' } },
                  }}
                  onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
                  />
                </Col>
              </Row>
              {
                !_.isUndefined(initialData) && initialData.recordDate
                  && <Row>
                    <Col span={24}>
                      <P bold margin='16px 6px'>วันที่บันทึกการขนส่ง: {moment(initialData.recordDate).format('DD MMMM YYYY')}</P>
                    </Col>
                  </Row>
              }
              {
                accessDelivered
                  && <Mutation
                    mutation={ASSIGN_DELIVERED}
                  >{(doAssign, { loading }) => (
                    <Div
                      position='fixed'
                      height='72px'
                      bottom='0'
                      left='0'
                      right='0'
                      style={{ background: `${color.primaryColor}33` }}
                      display='flex'
                      justifyContent='flex-end'
                      alignItems='center'
                      padding='0 32px 0 0'
                      zIndex={1}
                    >
                      <Button
                        text={props.text}
                        // weightRecordId,deliveryTime,deliveryDate,feeRate,endWeightvalue
                        disabled={disabled
                          || _.isUndefined(deliveryDate) || deliveryDate === 'Invalid date'
                          || _.isUndefined(deliveryTime) || deliveryTime === 'Invalid date'
                          || (_.size(assignDeliveredVariables) === 1 && !footerChanged)
                        }
                        loading={loading}
                        onClick={() => {
                          doAssign({
                            variables: {
                              ...assignDeliveredVariables,
                              totalWeight,
                              feeTotal: totalWeight * feeRate,
                              expensesHighway: mutationVariables.expensesHighway,
                              expensesEntranceStart: mutationVariables.expensesEntranceStart,
                              expensesEntranceEnd: mutationVariables.expensesEntranceEnd,
                              expensesPickupStart: mutationVariables.expensesPickupStart,
                              expensesPickupEnd: mutationVariables.expensesPickupEnd,
                              expensesOther: mutationVariables.expensesOther,
                              feePickupHeavy: mutationVariables.feePickupHeavy,
                              feePierEntrance: mutationVariables.feePierEntrance,
                              feePickupNormal: mutationVariables.feePickupNormal,
                              feeOther: mutationVariables.feeOther,
                              remark: mutationVariables.remark,
                              images: mutationVariables.images,
                            },
                          }).then((resp) => {
                            if (resp.data.AssignDelivered.success) {
                              setAssignDeliveredVariables({ id: parseInt(shippingOrderId, 10) })
                              message.success(resp.data.AssignDelivered.message)
                              history.push('/shipping-order')
                            } else {
                              message.error(resp.data.AssignDelivered.message)
                            }
                          })
                        }}
                      />
                    </Div>
                  )}
                  </Mutation>
              }
            </Div>
          : <Button
              {...props}
              onClick={() => setButtonPushed(true)}
              disabled={disabled}
            />
      }
    </Div>
  )
}

export const ExpenseSection = ({
  mutationVariables, initialData, disabled, onChangeHandler,
}) => {
  const style = {
    margin: '0 16px 0 0', width: '100%',
  }
  const expensesHighway = _.isUndefined(mutationVariables.expensesHighway) ? !_.isUndefined(initialData) && !_.isUndefined(initialData.expensesHighway) ? initialData.expensesHighway : 0 : mutationVariables.expensesHighway
  const expensesEntranceStart = _.isUndefined(mutationVariables.expensesEntranceStart) ? !_.isUndefined(initialData) && !_.isUndefined(initialData.expensesEntranceStart) ? initialData.expensesEntranceStart : 0 : mutationVariables.expensesEntranceStart
  const expensesEntranceEnd = _.isUndefined(mutationVariables.expensesEntranceEnd) ? !_.isUndefined(initialData) && !_.isUndefined(initialData.expensesEntranceEnd) ? initialData.expensesEntranceEnd : 0 : mutationVariables.expensesEntranceEnd
  const expensesPickupStart = _.isUndefined(mutationVariables.expensesPickupStart) ? !_.isUndefined(initialData) && !_.isUndefined(initialData.expensesPickupStart) ? initialData.expensesPickupStart : 0 : mutationVariables.expensesPickupStart
  const expensesPickupEnd = _.isUndefined(mutationVariables.expensesPickupEnd) ? !_.isUndefined(initialData) && !_.isUndefined(initialData.expensesPickupEnd) ? initialData.expensesPickupEnd : 0 : mutationVariables.expensesPickupEnd
  const expensesOther = _.isUndefined(mutationVariables.expensesOther) ? !_.isUndefined(initialData) && !_.isUndefined(initialData.expensesOther) ? initialData.expensesOther : 0 : mutationVariables.expensesOther
  const feePickupHeavy = _.isUndefined(mutationVariables.feePickupHeavy) ? !_.isUndefined(initialData) && !_.isUndefined(initialData.feePickupHeavy) ? initialData.feePickupHeavy : 0 : mutationVariables.feePickupHeavy
  const feePierEntrance = _.isUndefined(mutationVariables.feePierEntrance) ? !_.isUndefined(initialData) && !_.isUndefined(initialData.feePierEntrance) ? initialData.feePierEntrance : 0 : mutationVariables.feePierEntrance
  const feePickupNormal = _.isUndefined(mutationVariables.feePickupNormal) ? !_.isUndefined(initialData) && !_.isUndefined(initialData.feePickupNormal) ? initialData.feePickupNormal : 0 : mutationVariables.feePickupNormal
  const feeOther = _.isUndefined(mutationVariables.feeOther) ? !_.isUndefined(initialData) && !_.isUndefined(initialData.feeOther) ? initialData.feeOther : 0 : mutationVariables.feeOther
  return (
    <Row align='flex-start' type='flex' gutter={12} style={{ margin: '24px 0 0 0' }}>
      <Col span={12}>
        <Collapse bordered={false} defaultActiveKey='expense'>
          <Collapse.Panel style={customPanelStyle} header={`ค่าใช้จ่ายทั้งหมด: ${numeral(toSafeFloat(expensesEntranceStart) + toSafeFloat(expensesEntranceEnd) + toSafeFloat(expensesHighway) + toSafeFloat(expensesOther) + toSafeFloat(expensesPickupStart) + toSafeFloat(expensesPickupEnd)).format('0,0.00')} บาท`} key="expense">
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              isFloat={!disabled}
              data={{
                disabled,
                defaultValue: !_.isUndefined(initialData) ? initialData.expensesHighway : undefined,
                value: disabled ? numeral(expensesHighway).format('0,0.00') : expensesHighway,
                id: 'expensesHighway',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่าทางด่วน' } },
              }}
              onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              isFloat={!disabled}
              data={{
                disabled,
                defaultValue: !_.isUndefined(initialData) ? initialData.expensesEntranceStart : undefined,
                value: disabled ? numeral(expensesEntranceStart).format('0,0.00') : expensesEntranceStart,
                id: 'expensesEntranceStart',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่าเหยียบลานต้นทาง' } },
              }}
              onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              isFloat={!disabled}
              data={{
                disabled,
                defaultValue: !_.isUndefined(initialData) ? initialData.expensesEntranceEnd : undefined,
                value: disabled ? numeral(expensesEntranceEnd).format('0,0.00') : expensesEntranceEnd,
                id: 'expensesEntranceEnd',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่าเหยียบลานปลายทาง' } },
              }}
              onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              isFloat={!disabled}
              data={{
                disabled,
                defaultValue: !_.isUndefined(initialData) ? initialData.expensesPickupStart : undefined,
                value: disabled ? numeral(expensesPickupStart).format('0,0.00') : expensesPickupStart,
                id: 'expensesPickupStart',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่าขึ้น' } },
              }}
              onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              isFloat={!disabled}
              data={{
                disabled,
                defaultValue: !_.isUndefined(initialData) ? initialData.expensesPickupEnd : undefined,
                value: disabled ? numeral(expensesPickupEnd).format('0,0.00') : expensesPickupEnd,
                id: 'expensesPickupEnd',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่าลง' } },
              }}
              onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              isFloat={!disabled}
              data={{
                disabled,
                defaultValue: !_.isUndefined(initialData) ? initialData.expensesOther : undefined,
                value: disabled ? numeral(expensesOther).format('0,0.00') : expensesOther,
                id: 'expensesOther',
                unit: 'บาท',
                props: { ...style, title: { text: 'อื่นๆ' } },
              }}
              onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
          </Collapse.Panel>
        </Collapse>
      </Col>
      <Col span={12}>
        <Collapse bordered={false} defaultActiveKey='tariff'>
          <Collapse.Panel
            style={customPanelStyle}
            header={`ค่าธรรมเนียม (เบิกกับลูกค้า) ทั้งหมด: ${numeral(toSafeFloat(feePierEntrance) + toSafeFloat(feePickupNormal) + toSafeFloat(feePickupHeavy) + toSafeFloat(feeOther)).format('0,0.00')} บาท`}
            key="tariff"
          >
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              isFloat={!disabled}
              data={{
                disabled,
                defaultValue: !_.isUndefined(initialData) ? initialData.feePickupHeavy : undefined,
                value: disabled ? numeral(feePickupHeavy).format('0,0.00') : feePickupHeavy,
                id: 'feePickupHeavy',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่ายกตู้หนัก' } },
              }}
              onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              isFloat={!disabled}
              data={{
                disabled,
                defaultValue: !_.isUndefined(initialData) ? initialData.feePierEntrance : undefined,
                value: disabled ? numeral(feePierEntrance).format('0,0.00') : feePierEntrance,
                id: 'feePierEntrance',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่าผ่านท่าเรือ' } },
              }}
              onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              isFloat={!disabled}
              data={{
                disabled,
                defaultValue: !_.isUndefined(initialData) ? initialData.feePickupNormal : undefined,
                value: disabled ? numeral(feePickupNormal).format('0,0.00') : feePickupNormal,
                id: 'feePickupNormal',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่ายกตู้เปล่า' } },
              }}
              onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              isFloat={!disabled}
              data={{
                disabled,
                defaultValue: !_.isUndefined(initialData) ? initialData.feeOther : undefined,
                value: disabled ? numeral(feeOther).format('0,0.00') : feeOther,
                id: 'feeOther',
                unit: 'บาท',
                props: { ...style, title: { text: 'อื่นๆ' } },
              }}
              onChangeHandler={(key, value) => onChangeHandler(key, value, true)}
            />
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  )
}

const AssignFillingForm = ({
  shippingOrderId,
  disabled,
  isSpecial,
  haveInitial,
  initialData,
  defaultInitial,
  missingFuelAmount,
  requestedFuelAmount,
  accessFuel,
  setCreatingFuel,
  creatingFuel,
  fuelType,
  mutationVariables,
  refetch,
  props,
  isViewMode,
  accessSpecialFuel,
}) => {
  const title = isSpecial ? 'ใบเบิกน้ำมันพิเศษ' : 'ใบเบิกน้ำมัน'
  const initialTotalAmount = initialData?.totalAmount || missingFuelAmount

  const [getGasStationList, { data: gasStationListResponse, loading: gasStationListLoading }] = useLazyQuery(GAS_STATION_LIST)
  const gasStationList = gasStationListResponse?.GasstationList?.lists.map(v => ({ id: v.id, name: v.name })) || []
  const fetchGasStationList = (search) => {
    getGasStationList({
      variables: {
        name: search,
        isActive: true,
      },
    })
  }

  const [gasStationSearch, setGasStationSearch] = useState('')
  const [gasStationSelected, setGasStationSelected] = useState({})
  const [fuelId, setFuelId] = useState()
  const [successModal, setSuccessModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [assignFillingOrderVariables, setAssignFillingOrderVariables] = useState({
    id: parseInt(shippingOrderId, 10),
    fuelType: !_.isUndefined(defaultInitial) ? haveInitial ? initialData.fuelType : defaultInitial.Truck?.fuelType : undefined,
    kmPerLitre: initialData?.kmPerLitre || defaultInitial?.Truck?.TruckBrand?.fuelConsumptionRate,
    totalAmount: initialTotalAmount,
    specialReasonOther: initialData?.specialReasonOther || '',
  })

  const [buttonPushed, setButtonPushed] = useState(false)

  const style = {
    margin: '0 16px 0 0', width: '100%',
  }

  const onChange = (key, value) => {
    switch (key) {
      case 'specialReason':
        setAssignFillingOrderVariables({
          ...assignFillingOrderVariables,
          specialReason: value,
          specialReasonOther: '',
        })
        break
      default:
        setAssignFillingOrderVariables({
          ...assignFillingOrderVariables,
          [key]: value,
        })
    }
  }

  const mappingValueToStatusText = (value) => {
    if (_.isUndefined(value)) return 'ไม่ระบุ'
    const mapped = _.find(statusList, o => o.value === value.status)
    return (
      _.isUndefined(mapped) ? 'ไม่ระบุ' : mapped.text
    )
  }

  const mappingValueToStatusColor = (value) => {
    if (_.isUndefined(value)) return 'ไม่ระบุ'
    const mapped = _.find(statusList, o => o.value === value.status)
    return (
      !_.isUndefined(mapped) && mapped.color
    )
  }

  const download = () => {
    setIsLoading(true)
    window.open(
      `${getURL().FILE_SERVER}/downloadfile/pdf/fuelOrder/${fuelId}?t=${getAccessToken()}`,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    history.push('/shipping-order')
  }

  useEffect(() => {
    setAssignFillingOrderVariables({
      ...assignFillingOrderVariables,
      fuelType: !_.isUndefined(defaultInitial) ? haveInitial ? initialData.fuelType : defaultInitial.Truck.fuelType : undefined,
      kmPerLitre: initialData?.kmPerLitre || defaultInitial?.Truck?.TruckBrand?.fuelConsumptionRate,
      totalAmount: initialTotalAmount,
      specialReasonOther: initialData?.specialReasonOther || '',
    })
  }, [defaultInitial])

  useEffect(() => {
    fetchGasStationList(gasStationSearch)
  }, [gasStationSearch])

  const kmPerLitre = _.isUndefined(assignFillingOrderVariables.kmPerLitre) ? haveInitial ? initialData.kmPerLitre : undefined : assignFillingOrderVariables.kmPerLitre
  const totalAmount = _.isUndefined(assignFillingOrderVariables.totalAmount) ? haveInitial ? initialData.totalAmount : undefined : assignFillingOrderVariables.totalAmount
  const expiredDate = _.isUndefined(assignFillingOrderVariables.expiredDate) ? haveInitial ? initialData.expiredDate : undefined : assignFillingOrderVariables.expiredDate

  if (!(((!_.isUndefined(initialData) && haveInitial) || buttonPushed))) {
    return (<>
    <Button
      {...props}
      onClick={() => {
        setButtonPushed(true)
        setCreatingFuel(true)
      }}
      disabled={
        disabled
        || (
          defaultInitial
          && _.isEmpty(defaultInitial.Driver)
          && (!haveInitial || _.isNull(defaultInitial.Driver.id))
        )
        || creatingFuel
      }
    />
    {
      ((accessFuel && !isSpecial) && (creatingFuel || missingFuelAmount === 0))
      && <Mutation
        mutation={isSpecial ? CREATE_FUEL_ORDER : ASSIGN_FUEL}
      >{(doAssign, { loading }) => (
        <Div
          position='fixed'
          height='72px'
          bottom='0'
          left='0'
          right='0'
          style={{ background: `rgba(${color.primaryColorRGB}, 0.1)` }}
          display='flex'
          justifyContent='flex-end'
          alignItems='center'
          padding='0 32px 0 0'
          zIndex={1}
        >
          <Button
            text='บันทึกใบเบิกน้ำมัน'
            loading={loading}
            onClick={() => {
              const input = isSpecial ? {
                input: {
                  ...assignFillingOrderVariables,
                  remark: mutationVariables.remark,
                  images: mutationVariables.images,
                  shippingId: parseInt(shippingOrderId),
                  id: undefined,
                },
              } : {
                ...assignFillingOrderVariables,
                totalAmount: requestedFuelAmount,
                remark: mutationVariables.remark,
                images: mutationVariables.images,
                shippingId: undefined,
              }
              doAssign({
                variables: input,
              }).then((resp) => {
                const key = isSpecial ? 'CreateFuelOrder' : 'AssignFuelOrder'
                const response = resp.data[key]

                if (response.success) {
                  history.push('/shipping-order')
                } else {
                  message.error(response.message)
                }
              })
            }}
          />
        </Div>
      )}
      </Mutation>
    }
  </>)
  }
  return (
    <Div>
      <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 8px 0' }}>
        <Col span={16}>
          <div className='flex items-center mb-4'>
            <H4 bold color={theme.color.primaryColor} margin='0 24px 0 0'>{title}</H4>
            <p className='mr-8 !mb-0'>เล่มที่: {initialData?.shippingVolume}</p>
            <p className='mr-8 !mb-0'>เลขที่: {initialData?.shippingNumber}</p>
          </div>
        </Col>
        <Col span={8}>
          <Div display='flex' flexDirection='column'>
            <Checkbox
              disabled={disabled}
              defaultChecked={haveInitial ? initialData.isPaidByFleetCard : true}
              onChange={(e) => {
                onChange('isPaidByFleetCard', e)
              }}
            >จ่ายเงินด้วย FleetCard</Checkbox>
          </Div>
        </Col>
      </Row>
      <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 8px 0' }}>
        <Col span={8}>
          <P>ปั๊มน้ำมัน *</P>
        </Col>
        <Col span={8}>
          <P>รหัสปั๊มน้ำมัน</P>
        </Col>
        <Col span={8}>
          <P>บริษัท</P>
        </Col>
      </Row>
      <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
        <Col span={8}>
          <Select
            loading={gasStationListLoading}
            defaultValue={haveInitial && initialData?.Gasstation?.name}
            disabled={disabled}
            showSearch
            optionFilterProp="children"
            style={{ width: '100%' }}
            notFoundContent={gasStationListLoading ? <Spin size="small" /> : null}
            onSearch={e => setGasStationSearch(e)}
            onChange={(e) => {
              const selected = _.find(gasStationListResponse?.GasstationList?.lists, o => o.id === e)
              setGasStationSelected(selected)
              onChange('gasstationId', _.isNaN(parseInt(selected.id, 10)) ? undefined : parseInt(selected.id, 10))
            }}
            placeholder='พิมพ์รหัสปั๊มน้ำมัน'
          >
            {
              gasStationList.map((v, i) => <Select.Option key={i} value={v.id}>{v.name}</Select.Option>)
            }
          </Select>
        </Col>
        <Col span={8}>
          <P>
            {
              _.isEmpty(gasStationSelected)
                ? haveInitial
                  ? initialData?.Gasstation?.code
                  : '-'
                : gasStationSelected.code
            }
          </P>
        </Col>
        <Col span={8}>
          <P>
            {
              _.isEmpty(gasStationSelected)
                ? haveInitial
                  ? initialData?.Gasstation?.company
                  : '-'
                : gasStationSelected.company
            }
          </P>
        </Col>
      </Row>
      <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
        <Col span={8}>
          <InputWithLabelBlock
            isFloat={!disabled}
            data={{
              disabled: disabled || !isSpecial,
              value: disabled ? numeral(totalAmount).format('0,0.00') : totalAmount,
              id: 'totalAmount',
              props: { ...style, title: { text: 'ปริมาณทั้งหมด (ลิตร) *' } },
            }}
            onChangeHandler={(key, value) => {
              if (
                _.isNaN(value)
                || (value >= 0 && (value <= 500 || _.includes(FILLING_COMPANY, defaultInitial.JobInfo.Customer.companyName)))
              ) {
                onChange(key, value, true)
              }
            }}
          />
        </Col>
        <Col span={8} style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 70,
        }}>
          <P>ประเภทเชื้อเพลิง *</P>
          <Select
            disabled={disabled}
            showSearch
            defaultValue={haveInitial ? mappingValueToTypeText(initialData.fuelType) : !_.isNull(defaultInitial.Truck) ? mappingValueToTypeText(defaultInitial.Truck.fuelType) : mappingValueToTypeText(fuelType)}
            optionFilterProp="children"
            onChange={(e) => {
              const targetObj = _.find(fuelTypeList, r => r.value === e)
              onChange('fuelType', targetObj.value)
            }}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              fuelTypeList.map((v, i) => <Select.Option key={i} value={v.value}>{v.text}</Select.Option>)
            }
          </Select>
        </Col>
        <Col span={8}>
          <InputWithLabelBlock
            isFloat={!disabled}
            data={{
              disabled,
              value: disabled ? numeral(kmPerLitre).format('0,0.00') : kmPerLitre,
              id: 'kmPerLitre',
              props: { ...style, title: { text: 'อัตราเผาผลาญ (กิโลเมตร/ลิตร) *' } },
            }}
            onChangeHandler={(key, value) => onChange(key, value, true)}
          />
        </Col>
      </Row>
      <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 8px 0' }}>
        <Col span={8}>
          <DatePickerWithLabel
            disabledDate={current => current && current < moment().subtract(1, 'd').endOf('day')}
            data={{
              disabled,
              defaultValue: !_.isUndefined(defaultInitial) ? defaultInitial.expiredDate : undefined,
              value: !_.isUndefined(expiredDate) && moment(expiredDate),
              id: 'expiredDate',
              text: 'วันหมดอายุ *',
              props: { ...style },
            }}
            onChangeHandler={(key, value) => onChange(key, value)}
          />
        </Col>
        <Col span={8} style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 62,
        }}>
          <P>สถานะ</P>
          <P color={mappingValueToStatusColor(initialData)} bold>{haveInitial ? mappingValueToStatusText(initialData) : 'ยังไม่ได้สร้าง'}</P>
        </Col>
        <Col span={8} style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 62,
        }}>
          <P>ปริมาณที่เติมแล้ว</P>
          <P>{haveInitial ? numeral(initialData.filledAmount).format('0,0.00') : '-'} ลิตร</P>
        </Col>
      </Row>
      <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
        {defaultInitial.Driver.totalFuelamountCompensation < 0 && accessFuel && <Col span={8} style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 70,
        }}>
          <P color='red'>ต้องหักใบเบิกก่อนหน้า</P>
          <P color='red'>{numeral(defaultInitial.Driver.totalFuelamountCompensation).format('0,0.00')} ลิตร</P>
        </Col>
        }
      </Row>
      {
        isSpecial
        && (
          <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
            <Col span={8}>
              <Div display='block'>
                <P display='block' margin='0 0 16px'>เหตุผล</P>
                <Select
                  disabled={disabled}
                  style={{ width: '100%' }}
                  onChange={value => onChange('specialReason', value)}
                  value={assignFillingOrderVariables.specialReason || initialData?.specialReason}
                >
                  {
                    Object.keys(specialReason).map(key => (
                      <Select.Option key={key} value={specialReason[key].value}>
                        {specialReason[key].label}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Div>
            </Col>
            <Col span={8}>
              <InputWithLabelBlock
                data={{
                  disabled: disabled || assignFillingOrderVariables.specialReason !== specialReason.OTHER.value,
                  id: 'specialReasonOther',
                  props: { ...style, title: { text: 'กรอกเหตุผลอื่น ๆ' } },
                  value: assignFillingOrderVariables.specialReasonOther,
                }}
                onChangeHandler={(key, value) => onChange(key, value)}
              />
            </Col>
          </Row>
        )
      }
      { // status: lost
        haveInitial && initialData.status === fuelStatus.LOST
        && <Div>
          <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 8px 0' }}>
            <Col span={8}>
              <P>หักออกจากใบเบิกครั้งหน้า</P>
            </Col>
            <Col span={8}>
              <P>หักเบี้ยเลี้ยง</P>
            </Col>
          </Row>
          <Row align='flex-start' type='flex' gutter={12} style={{ margin: '0 0 16px 0' }}>
            <Col span={8}>
              <P color={color.error} bold>{haveInitial && -numeral(initialData.totalAmount).format('0,0.00')} ลิตร</P>
            </Col>
            <Col span={8}>
              <P color={color.error} bold>{haveInitial && numeral(initialData.fuelcompensation.totalDeduct).format('0,0.00')} บาท</P>
            </Col>
          </Row>
        </Div>
      }
      {
        creatingFuel && !isViewMode && ((accessFuel && !isSpecial) || (accessSpecialFuel && isSpecial))
        && <Mutation
          mutation={isSpecial ? CREATE_FUEL_ORDER : ASSIGN_FUEL}
        >{(doAssign, { loading }) => (
          <Div
            position='fixed'
            height='72px'
            bottom='0'
            left='0'
            right='0'
            style={{ background: `rgba(${color.primaryColorRGB}, 0.1)` }}
            display='flex'
            justifyContent='flex-end'
            alignItems='center'
            padding='0 32px 0 0'
            zIndex={1}
          >
            <Modal
              title={`เพิ่มใบสั่งเบิกน้ำมันในใบสั่งบรรทุก (รหัส: ${defaultInitial.shippingCode}) สำเร็จ`}
              visible={successModal}
              footer={[
                <AntButton key="back" disabled={isLoading} onClick={() => {
                  window.location = `/shipping-order/view/${shippingOrderId}`
                }}>
                  ภายหลัง
                </AntButton>,
                <AntButton key="submit" type="primary" loading={isLoading} onClick={() => download(false)}>
                  พิมพ์ใบเบิกน้ำมัน
                </AntButton>,
              ]}
            >
              <P>ต้องการพิมพ์ใบเบิกน้ำมันเลยหรือไม่?</P>
            </Modal>
            <Button
              text='บันทึกใบเบิกน้ำมัน'
              disabled={disabled
                || _.isUndefined(assignFillingOrderVariables.gasstationId)
                || _.isUndefined(assignFillingOrderVariables.expiredDate)
                // || _.isUndefined(assignFillingOrderVariables.pricePerLitre) || _.isNaN(assignFillingOrderVariables.pricePerLitre)
                || _.isUndefined(assignFillingOrderVariables.totalAmount) || _.isNaN(assignFillingOrderVariables.totalAmount)
                || _.isUndefined(assignFillingOrderVariables.kmPerLitre) || _.isNaN(assignFillingOrderVariables.kmPerLitre)
                || _.isUndefined(assignFillingOrderVariables.fuelType) || _.isNaN(assignFillingOrderVariables.fuelType)
                || loading
              }
              loading={loading}
              onClick={() => {
                if (_.isUndefined(assignFillingOrderVariables.expiredDate)) message.error('กรุณาระบุวันหมดอายุ')
                else {
                  const input = isSpecial ? {
                    input: {
                      ...assignFillingOrderVariables,
                      remark: mutationVariables.remark,
                      images: mutationVariables.images,
                      shippingId: parseInt(shippingOrderId),
                      id: undefined,
                    },
                  } : {
                    ...assignFillingOrderVariables,
                    totalAmount: requestedFuelAmount,
                    remark: mutationVariables.remark,
                    images: mutationVariables.images,
                    shippingId: undefined,
                  }
                  doAssign({
                    variables: input,
                  }).then((resp) => {
                    const key = isSpecial ? 'CreateFuelOrder' : 'AssignFuelOrder'
                    const response = resp.data[key]

                    if (response.success) {
                      const updatedId = isSpecial ? response.createdFuelOrder?.id : response.updatedShippingorder?.FuelOrder?.id
                      setFuelId(updatedId)
                      setSuccessModal(true)
                      setAssignFillingOrderVariables({ id: parseInt(shippingOrderId, 10) })
                      refetch()
                    } else {
                      message.error(response.message)
                    }
                  })
                }
              }}
            />
          </Div>
        )}
        </Mutation>
      }
    </Div>
  )
}
